import { fork } from "redux-saga/effects";
import activityPageSaga from "../components/activity-page/store/saga";
import bookingFormSaga from "../components/booking-form/store/saga";
import bookingPageSaga from "../components/booking-page/store/saga";
import bookingPricingSaga from "../components/booking-pricing/store/saga";
import bookingSearchSaga from "../components/booking-search/store/saga";
import bookingShowSaga from "../components/booking-show/store/saga";
import cargoTypeSaga from "../components/cargo-types/store/saga";
import changePasswordPageSaga from "../components/change-password-page/store/saga";
import companySaga from "../components/companies/store/saga";
import companyPageSaga from "../components/company-page/store/saga";
import countrySaga from "../components/countries/store/saga";
import documentSaga from "../components/documents/store/saga";
import forgotPasswordPageSaga from "../components/forgot-password-page/store/saga";
import invitationPageSaga from "../components/invitation-page/store/saga";
import loginPageSaga from "../components/login-page/store/saga";
import resetPasswordPageSaga from "../components/reset-password-page/store/saga";
import roleSaga from "../components/roles/store/saga";
import routeSaga from "../components/routes/store/saga";
import statusSaga from "../components/statuses/store/saga";
import userFiltersSaga from "../components/user-filters/store/saga";
import userPageSaga from "../components/user-page/store/saga";
import userSettingsSaga from "../components/user-settings/store/saga";
import userSaga from "../components/users/store/saga";
import vehicleTypeSaga from "../components/vehicle-types/store/saga";
import trailerTypeSaga from "../components/trailer-types/store/saga";
import registerPageSaga from "../components/register-page/store/saga";
import profilePageSaga from "../components/profile-page/store/saga";

function* rootSaga() {
  // Pages
  yield fork(loginPageSaga);
  yield fork(forgotPasswordPageSaga);
  yield fork(registerPageSaga);
  yield fork(resetPasswordPageSaga);
  yield fork(changePasswordPageSaga);
  yield fork(activityPageSaga);
  yield fork(bookingPageSaga);
  yield fork(invitationPageSaga);
  yield fork(companyPageSaga);
  yield fork(userPageSaga);
  yield fork(profilePageSaga);

  // Components
  yield fork(cargoTypeSaga);
  yield fork(routeSaga);
  yield fork(statusSaga);
  yield fork(vehicleTypeSaga);
  yield fork(trailerTypeSaga);
  yield fork(roleSaga);
  yield fork(companySaga);
  yield fork(bookingSearchSaga);
  yield fork(bookingFormSaga);
  yield fork(bookingShowSaga);
  yield fork(countrySaga);
  yield fork(userSettingsSaga);
  yield fork(userFiltersSaga);
  yield fork(bookingPricingSaga);
  yield fork(userSaga);
  yield fork(documentSaga);
}

export default rootSaga;
